export default {"src":"/_next/static/media/people-star.78823a6d.svg","height":66,"width":85};